






















import { Component, Prop, Vue } from "vue-property-decorator";
import * as XLSX from "xlsx";

interface ColumnaExport {
  label: string;
  field: string;
}

@Component
export default class ExportarExcelGenerico extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: Array<Record<string, unknown>>;
  @Prop({ type: Array, required: true }) readonly columns!: ColumnaExport[];
  @Prop({ type: String, required: true }) readonly fileName!: string;
  @Prop({ type: String, default: "Hoja 1" }) readonly sheetName!: string;

  private getValue(item: Record<string, unknown>, path: string): unknown {
    const parts = path.split(".");
    let current: unknown = item;
    for (const p of parts) {
      if (current == null || typeof current !== "object") return "";
      current = (current as Record<string, unknown>)[p];
    }
    return current ?? "";
  }

  exportExcel(): void {
    if (!this.items || this.items.length === 0) return;

    const data = this.items.map((item) => {
      const row: Record<string, unknown> = {};
      this.columns.forEach((c) => {
        row[c.label] = this.getValue(item, c.field);
      });
      return row;
    });

    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, this.sheetName || "Hoja 1");
    XLSX.writeFile(wb, this.fileName || "export.xlsx");
  }
}
